<template>
    <LoaderComponent v-if="isLoading && caracteristiques.length === 0" />
    <div v-else class="table-container">
        <DataTable :isLoading="isLoading" :not-sticky="true" :tableData="caracteristiques" :tableHeader="tableHeader" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import state from '@/modules/Preventif/store/modules/state';
import { store } from '@/plugins/store';
import LoaderComponent from '@/components/ui-components/LoaderComponent.vue';
import DataTable from '@/components/ui-components/DataTable.vue';
import { Operation } from '@/models/Operation';
import i18n from '@/plugins/i18n';
import { EquipementAction } from '@/modules/Equipements/store/actions-types';

export default defineComponent({
    name: 'GammeMaintenance',
    components: { LoaderComponent, DataTable },
    beforeMount() {
        store.dispatch(`equipementState/${EquipementAction.GET_OPERATION_MAINTENANCE}`, state.equipementId);
    },
    data() {
        const tableHeader: TableHeader[] = [
            {
                label: i18n.global.t('modale.equipment.gamme.maintenance.operations'),
                sortStatus: SortType.INACTIVE,
                sortData: '',
                width: '70%',
            },
            {
                label: i18n.global.t('modale.equipment.gamme.maintenance.periodicite'),
                sortStatus: SortType.INACTIVE,
                sortData: '',
                width: '30%',
            },
        ];
        return {
            tableHeader,
        };
    },
    computed: {
        isLoading(): boolean {
            return this.$store.getters['equipementState/getMaintenancesLoading'];
        },
        caracteristiques(): [] {
            return this.$store.getters['equipementState/getMaintenancesData'].map((c: Operation) => {
                return {
                    operation: c.libelle,
                    periodicite: c.periodicite,
                };
            });
        },
    },
});
</script>

<style scoped></style>
